import { Expose } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsString, ValidateIf } from 'class-validator';

export class PatientSummaryQueryDto {
  @Expose()
  @IsString()
  @IsNotEmpty()
  health_record_id: string;

  @Expose()
  @IsString()
  @IsOptional()
  skin_type_id?: string;

  @Expose()
  @IsString()
  @ValidateIf((val) => !val.mrn)
  ssn?: string;

  @Expose()
  @IsString()
  @ValidateIf((val) => !val.ssn)
  mrn?: string;

  @Expose()
  @IsString()
  @IsOptional()
  birth_date?: Date;

  @Expose()
  @IsString()
  @IsOptional()
  first_name?: string;

  @Expose()
  @IsString()
  @IsOptional()
  last_name?: string;

  @Expose()
  @IsString()
  @IsOptional()
  gender_id?: string;
}
